
import { Link } from "react-router-dom";
import { PlusCircle, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

interface EntriesHeaderProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const EntriesHeader = ({ searchTerm, setSearchTerm }: EntriesHeaderProps) => {
  const { language } = useLanguage();
  
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
      <div className="animate-fade-up">
        <h1 className="text-3xl font-bold tracking-tight">{t('entries.yourDiaryEntries', language)}</h1>
        <p className="text-muted-foreground mt-1">
          {t('entries.browseAndManage', language)}
        </p>
      </div>
      
      <div className="flex flex-col md:flex-row gap-2 animate-fade-up animation-delay-200">
        <div className="relative">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder={t('entries.searchEntries', language)}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full md:w-64 pl-9 transition-all duration-300 focus-within:w-72"
          />
        </div>
        <Button asChild className="transition-transform duration-300 hover:scale-105">
          <Link to="/generate" className="whitespace-nowrap">
            <PlusCircle className="h-4 w-4 mr-2" />
            {t('entries.newEntry', language)}
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default EntriesHeader;
